import { useEffect } from 'react';
import env from 'env';
import utils from 'utils';

/**
 * Injects the Contentsquare tracking tag into the document head.
 *
 * The tag id is provided at build time and is only set for production builds,
 * so nothing is injected in dev/local/staging. SSG prerendering is skipped.
 */
const useContentsquare = () => {
  useEffect(() => {
    if (!env.CONTENTSQUARE_TAG_ID || utils.isSSG()) return;

    const script = document.createElement('script');
    script.src = `https://t.contentsquare.net/uxa/${env.CONTENTSQUARE_TAG_ID}.js`;
    script.defer = true;
    document.head.appendChild(script);
  }, []);
};

export default useContentsquare;
